import { CanvasToolEntry } from '@panaya/ai-chat/shared';

/**
 * Generate Tests: seemore's Router calls the test builder agent through this tool, and its `tool_start` opens the
 * canvas. The Create action sends its `prompt` as a hidden message with `canvas.action: 'create'`.
 */
export const GENERATE_TESTS_CANVAS_TOOL: CanvasToolEntry = {
    tool: 'mcp__test_builder__generate_tests',
    flow: 'generate_tests',
    display_type: 'collection',
    title_key: 'seemore.canvas.generate_tests.title',
    progress_keys: {
        generating: 'seemore.canvas.generate_tests.progress.generating',
        preparing: 'seemore.canvas.generate_tests.progress.preparing',
        creating: 'seemore.canvas.generate_tests.progress.creating'
    },
    actions: [{ id: 'create', label_key: 'seemore.canvas.generate_tests.create', prompt: 'Create the selected tests', primary: true }]
};
